import request from '@/utils/request'

export function getTokenList(params) {
  return request({
    url: 'user/token',
    method: 'get',
    params
  })
}

export function deleteToken(id) {
  return request({
    url: 'user/token/' + id,
    method: 'delete'
  })
}

export function createToken(data) {
  return request({
    url: 'user/token',
    method: 'post',
    data
  })
}
